<!-- 新闻标题列表 -->
<template>
  <div class="video-list">
    <ul class="list">
      <li
        class=""
        v-for="(item, i) in listData"
        :key="i"
        @click="onListTitle(item)"
      >
        <div class="bag-img">
          <img :src="path + item.thumbnail" :alt="item.title" />
        </div>
        <div class="flex title-date">
          <p class="text_overflow title-text">{{ item.title }}</p>
          <span class="date">{{
            item.publishedDate
              ? item.publishedDate.split(' ')[0]
              : item.createdDate.split(' ')[0]
          }}</span>
        </div>
      </li>
    </ul>

    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.page"
        :page="[10, 20, 40, 60, 80, 100]"
        :page-size="params.size"
        layout="total, sizes, prev,slot, pager, next, jumper"
        :total="total"
        background
      >
        <span class="slot">
          {{ params.page + 1 }}/{{ Math.ceil(total / 10) }}
        </span>
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getArticleList } from '@/api/index'

export default {
  name: '',
  props: [],
  components: {},
  data() {
    return {
      params: {
        key: 'news.video.id',
        page: 0,
        size: 10
      },
      listData: [],
      total: 0,
      path: process.env.VUE_APP_BASE_API
    }
  },
  computed: {},
  watch: {},

  methods: {
    // 前往详情页
    onListTitle(item) {
      if (item.linkTo) {
        window.open(item.linkTo, '_blank')
      } else {
        this.$router.push({
          path: '/details',
          query: {
            id: item.id,
            title: this.$route.query.title,
            tag: this.$route.query.tag
            // key: this.$route.query.key
          }
        })
      }
    },

    handleSizeChange(val) {
      this.params.page = 0
      this.params.size = val
      this.getArticleList()
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 200)
    },
    handleCurrentChange(val) {
      this.params.page = val - 1
      this.getArticleList()
      setTimeout(() => {
        window.scrollTo(0, 0)
      }, 200)
    },
    getArticleList() {
      getArticleList(this.params)
        .then((res) => {
          this.listData = res.list
          this.total = res.count
        })
        .finally(() => {})
    }
  },
  mounted() {
    this.params.page = 0
    this.params.key = this.$route.query.key
    this.getArticleList()
  },
  created() {}
}
</script>

<style lang="scss" scope>
.video-list {
  background-color: #fff;
  padding: 16px 24px;
  .list {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    min-height: 500px;
    padding-left: 0;
    li {
      width: 364px;
      height: 268px;
      cursor: pointer;
      background: #ffffff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
      border-radius: 4px 4px 4px 4px;
      margin-bottom: 30px;
      padding: 8px;
      margin-right: 30px;

      &:hover {
        .title-text {
          color: #14579e;
          font-weight: 600;
          transform: scale(1.01);
        }
      }

      .bag-img {
        width: 100%;
        height: 210px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .title-text {
        color: #333;
        width: 62%;
      }
      .title-date {
        margin-top: 10px;
        justify-content: space-between;
        align-items: center;
        color: #888888;
      }
    }
    :nth-child(3n) {
      margin-right: 0;
    }
  }
  .el-pagination {
    .slot {
      display: none;
    }
  }
}
@media screen and (max-width: 768px) {
  .video-list {
    padding: 16px 0;
    .list {
      li {
        margin-right: 0px;
        width: 100%;
      }
    }
  }
}
</style>
